/** @format */

import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getNewsLink } from 'src/utils/helper';
import { format } from 'date-fns';
import { Rating } from 'src/components/Rating';
import { NewsSearch } from 'src/components/news/search';

export function NewsWidget({ data }) {
  const { t } = useTranslation();
  const history = useHistory();
  const newsType = data.newsType || 1;
  const handleSearchClick = () => {
    history.push(`/news/?query`);
  };

  return (
    <div className="news-widget" data-width={data.w} data-height={data.h}>
      <div className="news-widget--title">
        <h2>{data.title}</h2>
        <button className="search-button" onClick={handleSearchClick} />
      </div>
      {data.news && (
        <div className="news-widget--list-wrapper">
          <div className="news-widget--list">
            {data.news.length > 0 ? (
              data.news.map((item, index) => {
                const { rating, nid, title, date, category, content } = item;
                let dateFormated;
                if (typeof date === 'number')
                  dateFormated = format(new Date(date * 1000), 'dd.MM.yyyy') || '00.00.0000';
                else dateFormated = date;

                const NewsItem = () => {
                  return (
                    <>
                      <div className="news-widget--list-item-top">
                        <div className="news-widget--list-item-title">{title}</div>
                        <div className="news-widget--list-item-date">{dateFormated}</div>
                      </div>
                      {rating && rating !== 0 ? <Rating rating={rating} /> : null}
                      <div className="news-widget--list-item-text">{content}</div>
                    </>
                  );
                };

                if (item.link)
                  return (
                    <a
                      href={getNewsLink(item)}
                      target={`${item.linkTarget === '_blank' ? '_blank' : ''}`}
                      className="news-widget--list-item"
                      key={index}
                    >
                      <NewsItem />
                    </a>
                  );
                return (
                  <Link to={getNewsLink(item)} className="news-widget--list-item" key={index}>
                    <NewsItem />
                  </Link>
                );
              })
            ) : (
              <p className="news-widget--list-empty">{t('widget.noNews')}</p>
            )}
          </div>
        </div>
      )}
      <div className="news-widget--bottom">
        <div className="news-widget--link">
          <Link to={`/news`}>{t('widget.allNews')}</Link>
        </div>
      </div>
    </div>
  );
}
